var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndrawProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 108.3 108.3",
    style: {
      enableBackground: "new 0 0 108.3 108.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E6E6E6;}\n\t.st1{fill:#FFB8B8;}\n\t.st2{fill:#575A89;}\n\t.st3{fill:#2F2E41;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    transform: "translate(-191 -152.079)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    transform: "translate(282.246 224.353)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_944",
    className: "st0",
    d: "M17.1-18.1c0,10.5-3,20.8-8.8,29.6c-1.2,1.9-2.5,3.6-4,5.3c-3.4,4-7.3,7.4-11.6,10.3 c-1.2,0.8-2.4,1.5-3.6,2.2c-6.5,3.6-13.7,5.8-21,6.5c-1.7,0.2-3.4,0.2-5.1,0.2c-4.7,0-9.4-0.6-14-1.8c-2.6-0.7-5.1-1.6-7.6-2.6 c-1.3-0.5-2.5-1.1-3.7-1.8c-2.9-1.5-5.6-3.3-8.2-5.3c-1.2-0.9-2.3-1.9-3.4-2.9C-95.8,1.3-97.1-33-76.8-54.9s54.6-23.3,76.5-2.9 C10.8-47.6,17.1-33.2,17.1-18.1L17.1-18.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_945",
    className: "st1",
    d: "M-50.2-13.2c0,0,4.9,13.7,1.1,21.4s6,16.4,6,16.4s25.8-13.1,22.5-19.7s-8.8-15.3-7.7-20.8 L-50.2-13.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_185",
    className: "st1",
    cx: -40.6,
    cy: -25.5,
    rx: 17.5,
    ry: 17.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_946",
    className: "st2",
    d: "M-51.1,34.2c-2.6-0.7-5.1-1.6-7.6-2.6l0.5-13.3l4.9-11c1.1,0.9,2.3,1.6,3.5,2.3 c0.3,0.2,0.6,0.3,0.9,0.5c4.6,2.2,12.2,4.2,19.5-1.3c2.7-2.1,5-4.7,6.7-7.6L-8.8,9l0.7,8.4l0.8,9.8c-1.2,0.8-2.4,1.5-3.6,2.2 c-6.5,3.6-13.7,5.8-21,6.5c-1.7,0.2-3.4,0.2-5.1,0.2C-41.8,36.1-46.5,35.4-51.1,34.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_947",
    className: "st2",
    d: "M-47.7-0.9L-47.7-0.9l-0.7,7.2l-0.4,3.8l-0.5,5.6l-1.8,18.5c-2.6-0.7-5.1-1.6-7.6-2.6 c-1.3-0.5-2.5-1.1-3.7-1.8c-2.9-1.5-5.6-3.3-8.2-5.3l-1.9-9l0.1-0.1L-47.7-0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_948",
    className: "st2",
    d: "M-10.9,29.3c-6.5,3.6-13.7,5.8-21,6.5c0.4-6.7,1-13.1,1.6-18.8c0.3-2.9,0.7-5.7,1.1-8.2 c1.2-8,2.5-13.5,3.4-14.2l6.1,4L4.9,7.3l-0.5,9.5c-3.4,4-7.3,7.4-11.6,10.3C-8.5,27.9-9.7,28.7-10.9,29.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    className: "st2",
    d: "M-70.5,24.6c-1.2-0.9-2.3-1.9-3.4-2.9l0.9-6.1l0.7-0.1l3.1-0.4l6.8,14.8 C-65.2,28.3-67.9,26.6-70.5,24.6L-70.5,24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_950",
    className: "st2",
    d: "M8.3,11.5c-1.2,1.9-2.5,3.6-4,5.3c-3.4,4-7.3,7.4-11.6,10.3c-1.2,0.8-2.4,1.5-3.6,2.2l-0.6-2.8 l3.5-9.1l4.2-11.1l8.8,1.1C6.1,8.7,7.2,10.1,8.3,11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_951",
    className: "st3",
    d: "M-23.9-41.4c-2.7-4.3-6.8-7.5-11.6-8.9l-3.6,2.9l1.4-3.3c-1.2-0.2-2.3-0.2-3.5-0.2l-3.2,4.1 l1.3-4c-5.6,0.7-10.7,3.7-14,8.3c-4.1,5.9-4.8,14.1-0.8,20c1.1-3.4,2.4-6.6,3.5-9.9c0.9,0.1,1.7,0.1,2.6,0l1.3-3.1l0.4,3 c4.2-0.4,10.3-1.2,14.3-1.9l-0.4-2.3l2.3,1.9c1.2-0.3,1.9-0.5,1.9-0.7c2.9,4.7,5.8,7.7,8.8,12.5C-22.1-29.8-20.2-35.3-23.9-41.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_186",
    className: "st1",
    cx: -24.9,
    cy: -26.1,
    rx: 1.2,
    ry: 2.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawProfile);
export default __webpack_public_path__ + "static/media/undraw_profile.28817a9a525894d99d681c82d5f3a257.svg";
export { ForwardRef as ReactComponent };